import { splitPathParts } from './splitPathParts.js';

export const getUserPrefRoot = (path) => {
  const firstPart = splitPathParts(String(path || '').trim())[0] || '';
  // Match setDeep's existing literal-key and array-index path syntax.
  if (firstPart.startsWith('["') && firstPart.endsWith('"]')) {
    return firstPart.slice(2, -2);
  }
  return firstPart.split('[')[0];
};
